/**
 * Components
 */

// Shared
import Drawer from './shared/drawer';
import GMap from '../../shared/components/gmap';
import Table from './shared/table';

// Custom
import Numbers from './custom/numbers';

// ------
// Public
// ------

const index = () => {
	Drawer();

	Table.makeScrollable();

	// const gMapAllowed = (typeof window.ifabCookieConsent !== 'undefined') ? window.ifabCookieConsent.getConsent('googlemaps') : true;
	//
	// if (gMapAllowed && typeof window.pageInstance.settings.maps.google.id) {
	GMap.init(null, {
		apiKey  : window.pageInstance.settings.maps.google.id,
		settings: {
			// Siehe google-maps.js -> DEFAULTS
			map: {
				zoom: 14
			}
		}
	});
	// }

	Numbers.init();
};

// Export
export default index;
